// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.toggle_G9Qbv {
  position: relative;
  height : 28px;
  width : 56px;
  display: inline-block;
  opacity: 1;
  border-radius: 14px;
  -webkit-transition: opacity 0.25s;
  -webkit-transition: opacity 0.25s, left 0.25s;
  transition: opacity 0.25s, left 0.25s;
  -ms-touch-action: none;
      touch-action: none;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

.toggle_G9Qbv[data-disabled=true] {
  opacity: 0.5;
}

.toggle_G9Qbv .background_nk2Zu {
  background: white;
  border : 1px solid #D2D2D2;
  position : relative;
  width : 100%;
  height : 14px;
  margin-top:7px;
  border-radius: 28px;
  -webkit-transition : background-color 0.25s, -webkit-transform 0.25s, -webkit-box-shadow 0.15s;
  transition : background-color 0.25s, -webkit-transform 0.25s, -webkit-box-shadow 0.15s;
  transition : background-color 0.25s, transform 0.25s, box-shadow 0.15s;
  transition : background-color 0.25s, transform 0.25s, box-shadow 0.15s, -webkit-transform 0.25s, -webkit-box-shadow 0.15s;

}

.toggle_G9Qbv[data-value=true] .background_nk2Zu {
  background: #5A5CE2;
  border : 1px solid #D2D2D2;
}


.toggle_G9Qbv .handle_t8s4L {
  background: white;
  border-radius: 50%;
  position : absolute;
  border : 1px solid #D2D2D2;
  top:0;
  -webkit-transform : translateX( 0px );
          transform : translateX( 0px );
  width : 28px;
  height : 28px;
  -webkit-transition : background-color 0.25s, -webkit-transform 0.25s, -webkit-box-shadow 0.15s;
  transition : background-color 0.25s, -webkit-transform 0.25s, -webkit-box-shadow 0.15s;
  transition : background-color 0.25s, transform 0.25s, box-shadow 0.15s;
  transition : background-color 0.25s, transform 0.25s, box-shadow 0.15s, -webkit-transform 0.25s, -webkit-box-shadow 0.15s;
}


.toggle_G9Qbv[data-value=true] .handle_t8s4L {
  background: white;
  border-radius: 50%;
  position : absolute;
  border : 1px solid #D2D2D2;
  top:0;
  -webkit-transform : translateX( 28px );
          transform : translateX( 28px );
  left : auto;
  left : initial;
}

.toggle_G9Qbv .handle_t8s4L:focus {
  border-color:#5A5CE2;
  outline:none;
}

.toggle_G9Qbv.toggle-small_ouT8v {
  height : 20px;
  width : 40px;
}

.toggle_G9Qbv.toggle-small_ouT8v .handle_t8s4L {
  width : 20px;
  height : 20px;
}

.toggle_G9Qbv.toggle-small_ouT8v[data-value=true] .handle_t8s4L {
  -webkit-transform : translateX( 20px );
          transform : translateX( 20px );
}

.toggle_G9Qbv.toggle-small_ouT8v .background_nk2Zu {
  height : 20px;
  margin-top:0;
  border-radius: 20px;
}`, "",{"version":3,"sources":["webpack://./../../node_modules/@leverege/ui-elements/lib/esm/theme/Toggle.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,aAAa;EACb,YAAY;EACZ,qBAAqB;EACrB,UAAU;EACV,mBAAmB;EACnB,iCAAiC;EAEjC,6CAAqC;EAArC,qCAAqC;EACrC,sBAAkB;MAAlB,kBAAkB;EAClB,6CAA6C;EAC7C,yBAAyB;EACzB,sBAAsB;EACtB,qBAAqB;EACrB,iBAAiB;AACnB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,0BAA0B;EAC1B,mBAAmB;EACnB,YAAY;EACZ,aAAa;EACb,cAAc;EACd,mBAAmB;EACnB,8FAAsE;EAAtE,sFAAsE;EAAtE,sEAAsE;EAAtE,yHAAsE;;AAExE;;AAEA;EACE,mBAAmB;EACnB,0BAA0B;AAC5B;;;AAGA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;EACnB,0BAA0B;EAC1B,KAAK;EACL,qCAA6B;UAA7B,6BAA6B;EAC7B,YAAY;EACZ,aAAa;EACb,8FAAsE;EAAtE,sFAAsE;EAAtE,sEAAsE;EAAtE,yHAAsE;AACxE;;;AAGA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;EACnB,0BAA0B;EAC1B,KAAK;EACL,sCAA8B;UAA9B,8BAA8B;EAC9B,WAAc;EAAd,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,sCAA8B;UAA9B,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,mBAAmB;AACrB","sourcesContent":[".toggle {\n  position: relative;\n  height : 28px;\n  width : 56px;\n  display: inline-block;\n  opacity: 1;\n  border-radius: 14px;\n  -webkit-transition: opacity 0.25s;\n  -moz-transition: opacity 0.25s;\n  transition: opacity 0.25s, left 0.25s;\n  touch-action: none;\n  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);\n  -webkit-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n}\n\n.toggle[data-disabled=true] {\n  opacity: 0.5;\n}\n\n.toggle .background {\n  background: white;\n  border : 1px solid #D2D2D2;\n  position : relative;\n  width : 100%;\n  height : 14px;\n  margin-top:7px;\n  border-radius: 28px;\n  transition : background-color 0.25s, transform 0.25s, box-shadow 0.15s;\n\n}\n\n.toggle[data-value=true] .background {\n  background: #5A5CE2;\n  border : 1px solid #D2D2D2;\n}\n\n\n.toggle .handle {\n  background: white;\n  border-radius: 50%;\n  position : absolute;\n  border : 1px solid #D2D2D2;\n  top:0;\n  transform : translateX( 0px );\n  width : 28px;\n  height : 28px;\n  transition : background-color 0.25s, transform 0.25s, box-shadow 0.15s;\n}\n\n\n.toggle[data-value=true] .handle {\n  background: white;\n  border-radius: 50%;\n  position : absolute;\n  border : 1px solid #D2D2D2;\n  top:0;\n  transform : translateX( 28px );\n  left : initial;\n}\n\n.toggle .handle:focus {\n  border-color:#5A5CE2;\n  outline:none;\n}\n\n.toggle.toggle-small {\n  height : 20px;\n  width : 40px;\n}\n\n.toggle.toggle-small .handle {\n  width : 20px;\n  height : 20px;\n}\n\n.toggle.toggle-small[data-value=true] .handle {\n  transform : translateX( 20px );\n}\n\n.toggle.toggle-small .background {\n  height : 20px;\n  margin-top:0;\n  border-radius: 20px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"toggle": `toggle_G9Qbv`,
	"background": `background_nk2Zu`,
	"handle": `handle_t8s4L`,
	"toggle-small": `toggle-small_ouT8v`
};
export default ___CSS_LOADER_EXPORT___;
